const gold = {
  lineItems: [
    {
      variantId: '43361746616371',
      quantity: 1,
      sellingPlanId: '1985216563',
      attributes: [ 
        { key: '_inveterate_subscription', value: 'true' }
      ]
    }   
  ]
}

const silver = {
  lineItems: [
    {
      variantId: '43361747828787',
      quantity: 1,
      sellingPlanId: '1985249331',
      attributes: [ 
        { key: '_inveterate_subscription', value: 'true' }
      ]
    }
  ]
}


if(window.Tapcart.isInitialized){
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[inveterate-tier-atc-button]');
    if (button) {
      const tierId = button.getAttribute('inveterate-tier-id');

      if (tierId == 'd044e920') {
        hybridAddToCart(gold)
      } else if (tierId == '9b7d1d48') {
        hybridAddToCart(silver)
      }
    }
  });
}  

const hybridAddToCart = (params) => {
   if(window.Tapcart.isInitialized){
      window.Tapcart.actions.action('cart/add', params);
   } 
}